export const categories = [
  {
    slug: 'official-entry',
    name: '官方入口',
    icon: 'ri-link',
    description: '爱情岛论坛官方最新入口地址，确保访问安全稳定',
    color: 'primary',
  },
  {
    slug: 'backup-links',
    name: '备用线路',
    icon: 'ri-router-line',
    description: '当主站无法访问时，通过备用线路快速进入论坛',
    color: 'accent',
  },
  {
    slug: 'community-resources',
    name: '社区资源',
    icon: 'ri-group-line',
    description: '社区精华帖、热门话题、用户分享等优质内容汇总',
    color: 'secondary',
  },
  {
    slug: 'latest-news',
    name: '最新资讯',
    icon: 'ri-newspaper-line',
    description: '爱情岛论坛最新公告、活动通知及行业动态',
    color: 'primary',
  },
  {
    slug: 'tutorials',
    name: '使用教程',
    icon: 'ri-book-open-line',
    description: '论坛注册、发帖、升级等详细操作指南',
    color: 'accent',
  },
  {
    slug: 'mobile-access',
    name: '移动端入口',
    icon: 'ri-smartphone-line',
    description: '手机访问爱情岛论坛的专属入口和APP下载',
    color: 'secondary',
  },
];